<div class="section over-hide padding-top-120 padding-top-mob-nav section-background-rana-3 background-img-top">
    <div class="section-1400 padding-top-bottom-120">
        <div class="container-fluid">
            <div class="row justify-content-center">
                <div class="col-lg-7 col-xl-5">

                    <small *ngIf="loginError" class="font-weight-500">Invalid login, Please verify email or
                        password</small>

                    <div
                            class="section py-4 py-md-5 px-3 px-sm-4 px-lg-5 over-hide border-4 section-shadow-blue bg-white section-background-24 background-img-top form nfr-auth-form">
                        <form [formGroup]="loginForm" class="section nfr-form-standard" (keydown.enter)="loginWithJWt()">
                            <h4 class="mb-4 text-sm-center">Sign in.</h4>
                            <div *ngIf="email?.invalid && (email?.dirty || email?.touched)">
                                <small *ngIf="email?.errors?.['required']" class="font-weight-500">Email is
                                    required.</small>
                                <small class="font-weight-500" *ngIf="email?.errors?.['email']">Invalid email
                                    format.</small>
                            </div>
                            <div class="form-group">

                                <input type="text" [(ngModel)]="loginData.email" name="loginData.email"
                                       formControlName="email"
                                       class="form-style big gray-version no-shadow form-style-with-icon section-shadow-blue nfr-input-control"
                                       placeholder="Email Id" autocomplete="off"/>

                                <i class="input-icon big uil uil-user"></i>
                            </div>
                            <div *ngIf="
                    password?.invalid && (password?.dirty || password?.touched)
                  ">
                                <small class="font-weight-500" *ngIf="password?.errors?.['required']">Password is
                                    required.</small>
                                <small class="font-weight-500" *ngIf="password?.errors?.['minlength']">
                                    Password must be at least 6 characters long.
                                </small>
                            </div>
                            <div class="form-group">

                                <input type="password" [(ngModel)]="loginData.password" formControlName="password"
                                       name="loginData.password"
                                       class="form-style big gray-version no-shadow form-style-with-icon section-shadow-blue nfr-input-control"
                                       placeholder="Password" autocomplete="off"/>
                                <i class="input-icon big uil uil-lock-alt"></i>
                            </div>
                            <div class="row mt-3">
                                <div class="col pr-0">
                                    <div class="form-group">
                                        <!-- <input type="checkbox" id="checkbox" checked />
                                        <label class="checkbox mb-0 font-weight-500 size-15" for="checkbox">Stay signed in</label> -->
                                    </div>
                                </div>
                                <div class="col-auto align-self-center text-right pl-0">
                                    <a routerLink="/recover-password"
                                       class="link link-gray-primary size-15 font-weight-500 animsition-link"
                                       data-hover="Forgot password?">Forgot password?</a>
                                </div>
                            </div>
                            <div class="row mt-4">
                                <div class="col-12 text-sm-center">
                                    <button type="button" (click)="loginWithJWt()" class="btn btn-dark-primary nfr-btn">
                                        Sign in<i class="uil uil-arrow-right size-22 ml-3"></i>
                                    </button>
                                </div>
                            </div>
                            <p class="mt-4 mb-0 text-sm-center size-16">
                                Not registered?
                                <a routerLink="/register-form"
                                   class="link link-dark-primary-2 link-normal animsition-link">Create an
                                    account</a>
                            </p>
                            <p class="mb-0 text-sm-center size-16">
                                Couldn't find your email?
                                <a routerLink="/contact-us" class="link link-primary link-normal animsition-link">Contact
                                    Us</a>
                            </p>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

